import Vue from 'vue';
import * as Lib from '@ext/index';
import moment, { Moment } from 'moment';
import { isString } from 'util';
import { Random } from '@ext/index';

export class ControladorDeAutenticacion extends Vue
{
    public Fecha: Moment = moment();
    public Posibles: { Fecha: Moment; }[] = [];
    ModificarFecha( fecha: string )
    {
        this.Fecha = moment( fecha );

        this.Posibles.clear();
        let e = Random.Enteros( 1, 6 );
        for ( var i = 0; i < e; i++ )
        {
            let hora = Random.Enteros( 8, 18 );
            if ( this.Posibles.findIndex( x => x.Fecha.get( 'hour' ) == hora  ) == -1 )
                this.Posibles.push( { Fecha: this.Fecha.clone().set( "hours", hora ) } );
        }
        this.Posibles = this.Posibles.sort( ( x, y ) => x.Fecha.toDate().getTime() - y.Fecha.toDate().getTime() );
        this.$emit( 'change' );
    }

}


const Controlador = new ControladorDeAutenticacion();
export { Controlador };